import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1aa679fa")

_pushScopeId("data-v-1aa679fa")
const _hoisted_1 = { class: "mb-2 pb-2 border-b" }
const _hoisted_2 = { class: "flex border-b items-center pb-2 mb-2" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "text-4xl font-semibold mb-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" View Objectives ")
const _hoisted_6 = {
  key: 1,
  class: "ml-auto w-20 h-20 border bg-background rounded"
}
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { class: "" }, "Grade", -1)
const _hoisted_12 = { disabled: "" }
const _hoisted_13 = { class: "mb-2" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { class: "" }, "Event comments", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Saving event")
const _hoisted_16 = { class: "max-w-2xl h-450 flex flex-col" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "p-8 pb-4 text-2xl border-b" }, "Objectives", -1)
const _hoisted_18 = { class: "p-8 pt-2 overflow-y-auto h-full mb-8" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_button_component = _resolveComponent("button-component")
  const _component_icon_component = _resolveComponent("icon-component")
  const _component_loading_indicator_component = _resolveComponent("loading-indicator-component")
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createBlock("section", {
    class: "p-4 px-8 h-full flex flex-col",
    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, " Event " + _toDisplayString(_ctx.viewModel.event.name), 1),
          _createVNode(_component_button_component, {
            small: true,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDescription = !_ctx.showDescription))
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        (_ctx.viewModel.icon)
          ? (_openBlock(), _createBlock(_component_icon_component, {
              key: 0,
              icon: _ctx.viewModel.icon,
              class: "ml-auto w-20 h-20"
            }, null, 8, ["icon"]))
          : (_openBlock(), _createBlock("div", _hoisted_6))
      ]),
      _createVNode("div", _hoisted_7, "Phase: " + _toDisplayString(_ctx.viewModel.event.phase), 1),
      _createVNode("div", _hoisted_8, "Category: " + _toDisplayString(_ctx.viewModel.event.category), 1),
      _createVNode("div", _hoisted_9, "Hours: " + _toDisplayString(_ctx.viewModel.event.hours), 1),
      _createVNode("div", null, "Medium: " + _toDisplayString(_ctx.viewModel.event.medium), 1)
    ]),
    _createVNode("div", _hoisted_10, [
      _hoisted_11,
      _withDirectives(_createVNode("select", {
        class: "w-full select mb-2",
        disabled: _ctx.readonly,
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleGradeChange && _ctx.handleGradeChange(...args))),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.gradeModel = $event))
      }, [
        _createVNode("option", _hoisted_12, _toDisplayString(_ctx.defaultDropdownText), 1),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dropdownItems, (gradeItem, index) => {
          return (_openBlock(), _createBlock("option", {
            key: index,
            value: gradeItem
          }, _toDisplayString(gradeItem.text), 9, ["value"]))
        }), 128))
      ], 40, ["disabled"]), [
        [_vModelSelect, _ctx.gradeModel]
      ])
    ]),
    _createVNode("div", _hoisted_13, [
      _hoisted_14,
      _withDirectives(_createVNode("textarea", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.commentModel = $event)),
        onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.debouncedCommentChange && _ctx.debouncedCommentChange(...args))),
        disabled: _ctx.readonly,
        class: "textarea"
      }, null, 40, ["disabled"]), [
        [_vModelText, _ctx.commentModel]
      ])
    ]),
    _createVNode(_component_loading_indicator_component, { isLoading: _ctx.isLoading }, {
      default: _withId(() => [
        _hoisted_15
      ]),
      _: 1
    }, 8, ["isLoading"]),
    (_ctx.showDescription)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDescription = false))
        }, {
          default: _withId(() => [
            _createVNode("section", _hoisted_16, [
              _hoisted_17,
              _createVNode("div", _hoisted_18, _toDisplayString(_ctx.event.objectives), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
})